import React, { useState } from "react";
import { connect } from "react-redux";
import SRHCopyright from "./../../../../components/SRHCopyright";
import ReportHeader from "./../../../../components/ReportHeader";
import ScatterPlot from "./../../../../components/ScatterPlot";
import Printable from "./../../../../components/Printable";
import clsx from "clsx";
import _ from "lodash";
import FiltersFooter from "../FiltersFooter";
import Slider from "@material-ui/core/Slider";
import {
  ScatterPlotWrapper,
  TopFloatingSlider,
  BottomFloatingSlider,
  SliderBackground,
  SliderLabel,
} from "./style.js";

const ScatterPlots = ({
  summaryReport,
  landscape,
  configuration,
  scatterPlots,
  unit,
  ready,
  page,
}) => {
  const {
    survey,
    totalRespondents,
    datasetName,
    workSettingsSurveyed,
    actualSurvey,
    comparativeDatasets,
  } = summaryReport;
  if (!ready || scatterPlots.length < 1) {
    return <Printable landscape={landscape} />;
  }

  let comparativeDatasetsParsed;
  if (comparativeDatasets) {
    comparativeDatasetsParsed = comparativeDatasets
      .split("||")
      .map((str) => str.split("|"));
  } else {
    comparativeDatasetsParsed = [["singleyear", "this"]];
  }
  const comparativeDatasetsLookup = {};
  comparativeDatasetsParsed.forEach((dataset, index) => {
    comparativeDatasetsLookup[dataset[0]] = index;
  });

  const [yearIndex, setYearIndex] = useState(0);

  const selectedYear = comparativeDatasetsParsed[yearIndex][0];

  const displayPositionScatterPlot =
    scatterPlots.length > 0 &&
    _.filter(scatterPlots[1][yearIndex].data.points, function (point) {
      return point.key !== "Other";
    }).length > 1;
  const isPulse = survey && survey.indexOf("Pulse") > -1;

  let type = "DEFAULT";
  if (isPulse) {
    if (/SUTTER_Pulse/.test(actualSurvey)) {
      type = "SUTTER_PULSE";
    } else if (/STANFORD_Pulse_2021/.test(actualSurvey)) {
      type = "STANFORD_Pulse_2021";
    } else if (/RISE_Pulse_2023/.test(actualSurvey)) {
      type = "RISE_Pulse_2023";
    } else if (/SRH_Pulse_2022/.test(actualSurvey) || /SRH_Pulse_2022a/.test(actualSurvey)) {
      type = "SRH_Pulse_2022";
    } else if (/VIZ_BNCHMRK_Pulse_2022/.test(actualSurvey)) {
      type = "VIZ_BNCHMRK_Pulse_2022";
    } else if (/PENN.*_Pulse_2020/.test(actualSurvey)) {
      type = "PENN_2020_PULSE";
    } else if (/QUEENS_Pulse_2023/.test(actualSurvey)) {
      type = "QUEENS_Pulse_2023";
    } else {
      type = "PULSE";
    }
  } else if (/TRINITY/.test(actualSurvey)) {
    type = "TRINITY";
  } else if (/HSOPS/.test(actualSurvey)) {
    type = "HSOPS";
  } else if (/MOSOPS/.test(actualSurvey)) {
    type = "MOSOPS";
  } else if (/NHSOPS/.test(actualSurvey)) {
    type = "NHSOPS";
  } else if (/ASC_SOPS_2023/.test(actualSurvey)) {
    type = "ASC_SOPS_2023";
  }

  let scatterplotDefinitions = [];
  const { scatterplots } = configuration;

  if (scatterplots && scatterplots.axisVariables && Array.isArray(scatterplots.axisVariables)) {

    scatterplotDefinitions = scatterplots.axisVariables;
  } else {
      switch (type) {
        case "SUTTER_PULSE":
          scatterplotDefinitions.push({
            questionX:
              "The learning environment utilizes input/suggestions from the people that work here. (% Positive)",
            questionY:
              "My direct supervisor / manager regularly makes time to provide positive feedback to me about how I am doing. (% Positive)",
          });
          scatterplotDefinitions.push({
            questionX:
              "The culture in this department makes it easy to learn from errors of others. (% Positive)",
            questionY:
              "I would feel safe being treated here as a patient. <br /> (% Positive)",
          });
          break;
        case "STANFORD_Pulse_2021":
          scatterplotDefinitions.push({
            questionX:
              "My suggestions about quality would be acted upon if I expressed them to management.",
            questionY:
              "In this work setting, it is difficult to speak up if I perceive a problem with patient care.",
          });
          scatterplotDefinitions.push({
            questionX:
              "In this work setting, it is difficult to discuss errors.",
            questionY:
              "Communication breakdowns are common in this work setting.",
          });
          break;
        case "RISE_Pulse_2023":
          scatterplotDefinitions.push({
            questionX:
              "My suggestions about quality would be acted upon if I expressed them to management.",
            questionY:
              "In this work setting, it is difficult to speak up if I perceive a problem with patient care.",
          });
          scatterplotDefinitions.push({
            questionX:
              "In this work setting, it is difficult to discuss errors.",
            questionY:
              "Communication breakdowns are common in this work setting.",
          });
          break;
        case "VIZ_BNCHMRK_Pulse_2022":
        scatterplotDefinitions.push({
          questionX:
            "My suggestions about quality would be acted upon if I expressed them to management.",
          questionY:
            "In this work setting, it is difficult to speak up if I perceive a problem with patient care.",
        });
        scatterplotDefinitions.push({
          questionX:
            "In this work setting, it is difficult to discuss errors.",
          questionY:
            "Communication breakdowns are common in this work setting.",
        });
        break;
        case "SRH_Pulse_2022":
          scatterplotDefinitions.push({
            questionX:
              "Overall, I believe the acquisition will be good for me personally.",
            questionY:
              "I am feeling optimistic about my future at Vizient.",
          });
          scatterplotDefinitions.push({
            questionX:
              "Overall, I believe the acquisition will be good for our organization.",
            questionY:
              "I am feeling supported as I process this change.",
          });
        break;
        case "PENN_2020_PULSE":
          scatterplotDefinitions.push({
            questionX:
              "In this work setting, the learning environment effectively fixes defects to improve the quality of what we do.",
            questionY:
              "In this work setting, local management regularly makes time to provide positive feedback to me about how I am doing.",
          });
          scatterplotDefinitions.push({
            questionX:
              "In this work setting, it is difficult to speak up if I perceive a problem with patient care. (% Positive)",
            questionY:
              "I would feel safe being treated here as a patient. (% Positive)",
          });
          break;
          case "QUEENS_Pulse_2023":
            scatterplotDefinitions.push({
              questionX:
                "It is easy for personnel here to ask questions when there is something that they do not understand.",
              questionY:
                "The culture in this work setting makes it easy to learn from the errors of others.",
            });
            scatterplotDefinitions.push({
              questionX:
                "My suggestions about quality would be acted upon if I expressed them to management.",
              questionY:
                "In this work setting, it is difficult to speak up if I perceive a problem with patient care.",
            });
            break;
        case "PULSE":
          scatterplotDefinitions.push({
            questionX:
              "In this work setting, the learning environment utilizes input/suggestions from the people that work here. (% Positive)",
            questionY:
              "In this work setting, local leadership regularly makes time to provide positive feedback to me about how I am doing. (% Positive)",
          });
          if ((actualSurvey !== "USC_KECK_Pulse_2022" && actualSurvey !== "BILLINGS_Pulse_2022" && actualSurvey !== "BILLINGS_Pulse_Magnet_2022_3" && actualSurvey !== "RISE_Pulse_2023")) {
            scatterplotDefinitions.push({
              questionX:
                "The culture in this work setting makes it easy to learn from the errors of others. (% Positive)",
              questionY:
                "In this work setting, local leadership provides useful feedback about my performance. (% Positive)",
            });
          }
          break;
        case "TRINITY":
          scatterplotDefinitions.push({
            domainX: "Teamwork (% Positive)",
            domainY: "Safety Climate (% Positive)",
          });
          scatterplotDefinitions.push({
            domainX: "Local Leadership (% Positive)",
            domainY: "Burnout Climate (% Positive)",
          });
          break;
        case "HSOPS":
          scatterplotDefinitions.push({
            domainX: "Teamwork (% Positive)",
            domainY: "Reporting Patient Safety (% Positive)",
          });
          scatterplotDefinitions.push({
            domainX: "Communication about Error (% Positive)",
            domainY: "Mgmt. Support for Patient Safety (% Positive)",
          });
          break;
        case "MOSOPS":
          scatterplotDefinitions.push({
            domainX: "Teamwork (% Positive)",
            domainY: "Perceptions of Patient Safety (% Positive)",
          });
          scatterplotDefinitions.push({
            domainX: "Communication about Error (% Positive)",
            domainY: "Leadership Support for Patient Safety (% Positive)",
          });
          break;
        case "NHSOPS":
          scatterplotDefinitions.push({
            domainX: "Teamwork (% Positive)",
            domainY: "Perceptions of Patient Safety (% Positive)",
          });
          scatterplotDefinitions.push({
            domainX: "Communication about Incidents (% Positive)",
            domainY: "Management Support for PS (% Positive)",
          });
          break;
          case "ASC_SOPS_2023":
            scatterplotDefinitions.push({
              domainX: "Teamwork (% Positive)",
              domainY: "Communication Openness (% Positive)",
            });
            scatterplotDefinitions.push({
              domainX: "Organizational Learning – Continuous Improvement (% Positive)",
              domainY: "Management Support for Patient Safety (% Positive)",
            });
            break;
        case "DEFAULT":
        default:
          scatterplotDefinitions.push({
            domainX: "Teamwork (% Positive)",
            domainY: "Safety Climate (% Positive)",
          });
          scatterplotDefinitions.push({
            domainX: "Improvement Readiness (% Positive)",
            domainY: "Local Leadership (% Positive)",
          });
      }
  }

  const scatterPlotsToDisplay = [];
  scatterplotDefinitions.forEach((scatterplotDefinition, index) => {
    scatterPlotsToDisplay.push(
      <ScatterPlot
        key={index * 2}
        data={scatterPlots[index * 2][yearIndex].data}
        allYearsData={scatterPlots[index * 2]}
        unit={unit}
        displayType="Work Settings"
        ready={ready}
        summaryReport={summaryReport}
        landscape={landscape}
        configuration={configuration}
        selectedYear={selectedYear}
        {...scatterplotDefinition}
      />
    );
    if (displayPositionScatterPlot) {
      scatterPlotsToDisplay.push(
        <ScatterPlot
          key={index * 2 + 1}
          data={scatterPlots[index * 2 + 1][yearIndex].data}
          allYearsData={scatterPlots[index * 2 + 1]}
          unit={unit}
          displayType="Positions"
          ready={ready}
          summaryReport={summaryReport}
          landscape={landscape}
          configuration={configuration}
          selectedYear={selectedYear}
          {...scatterplotDefinition}
        />
      );
    }
  });

  let surveyTitle = survey && survey.replace(/_Pulse/g, "");
  if (survey === "SELECT_2020") surveyTitle = "SCORE";
  if (survey === "VALLEY_2020") surveyTitle = "SCOR";
  if (survey === "SHA_2020") surveyTitle = "SCORE";
  if (/PENN.*_Pulse_2020/.test(survey)) surveyTitle = "SCORE";
  if (configuration && configuration.survey_title)
    surveyTitle = configuration.survey_title;

  const sliderOnChange = (event, value) => {
    setYearIndex(comparativeDatasetsLookup[value]);
  };

  const yearsWithData = new Set();
  scatterPlots.forEach((scatterPlot) => {
    scatterPlot.forEach((dataset) => {
      if (dataset.data.points.length > 0) {
        yearsWithData.add(dataset.year);
      }
    });
  });
  const marks = comparativeDatasetsParsed
    .filter((dataset) => yearsWithData.has(dataset[0]))
    .map((dataset) => ({
      value: parseInt(dataset[0], 10),
    }));

  const slider = marks.length > 1 && !landscape && (
    <React.Fragment>
      <SliderBackground marks={marks}>
        <Slider
          value={parseInt(selectedYear, 10)}
          onChange={sliderOnChange}
          marks={marks}
          min={marks[marks.length - 1].value}
          max={marks[0].value}
          step={null}
          valueLabelDisplay="on"
        />
      </SliderBackground>
      <SliderLabel>Show data by year</SliderLabel>
    </React.Fragment>
  );

  return (
    <div>
      <Printable key="page-1" page={page} landscape={landscape}>
        <ReportHeader
          title={`Scatterplots of Key ${surveyTitle} ${
            isPulse ? "Items" : "Domains"
          }`}
          totalRespondents={totalRespondents}
          workSettingsSurveyed={workSettingsSurveyed}
          datasetName={datasetName}
          unit={unit}
          summaryReport={summaryReport}
        />
        <ScatterPlotWrapper className={clsx({ landscape })}>
          {scatterPlotsToDisplay[0]}
          <TopFloatingSlider>{slider}</TopFloatingSlider>
          {scatterPlotsToDisplay[1] ? (
            <React.Fragment>
              {scatterPlotsToDisplay[1]}
              <BottomFloatingSlider>{slider}</BottomFloatingSlider>
            </React.Fragment>
          ) : (
            <div
              style={{
                textAlign: "center",
                color: "#777",
                fontWeight: "300",
                padding: "160px 240px",
              }}
            >
              There are not enough position types within this work setting to
              display the scatterplot by position type.
            </div>
          )}
        </ScatterPlotWrapper>
        <FiltersFooter />
        <SRHCopyright textClass="large-font" />
      </Printable>
      {scatterPlotsToDisplay[2] && (
        <Printable key="page-2" page={page + 1} landscape={landscape}>
          <ReportHeader
            title={`Scatterplots of Key ${surveyTitle} ${
              isPulse ? "Items" : "Domains"
            } (cont.)`}
            totalRespondents={totalRespondents}
            workSettingsSurveyed={workSettingsSurveyed}
            datasetName={datasetName}
            unit={unit}
            summaryReport={summaryReport}
          />
          <ScatterPlotWrapper className={clsx({ landscape })}>
            {scatterPlotsToDisplay[2]}
            <TopFloatingSlider>{slider}</TopFloatingSlider>
            {scatterPlotsToDisplay[3] && (
              <React.Fragment>
                {scatterPlotsToDisplay[3]}
                <BottomFloatingSlider>{slider}</BottomFloatingSlider>
              </React.Fragment>
            )}
          </ScatterPlotWrapper>
          <FiltersFooter />
          <SRHCopyright textClass="large-font" />
        </Printable>
      )}
    </div>
  );
};

export default connect((store) => {
  return {
    summaryReport: store.summaryReport.summaryReport,
    scatterPlots: store.scatterPlots.scatterPlots,
  };
})(ScatterPlots);


// WEBPACK FOOTER //
// ./src/pages/SummaryReport/components/ScatterPlots/index.jsx